import React, {useEffect} from "react";
import {Grid, Typography} from "@mui/material";
import useMyGroup from "../styles/my_group/myGroup";
import TeaserInviteFriends from "../components/my_group/TeaserInviteFriends";
import UntoldMixologist from "../components/my_group/UntoldMixologist";
import DidYouKnowComponent from "../components/DidYouKnowComponent";
import ListInfo from "../components/kozel/ListInfo";
import MyGroupMix from "../components/my_group/MyGroupMix";
import {useAppDispatch} from "../stores/store";
import {getMyGroup} from "../features/profile/myGroupSlice";
import GameSpinBottleHistory from "../components/kozelMeet/GameSpinBottleHistory";

const MyGroup: React.FC = () => {
    const dispatch = useAppDispatch();
    const myGroup = useMyGroup();

    useEffect(() => {
        dispatch(getMyGroup());
    }, [dispatch])

    const listInfoItems = [
        {text: 'Your friends;'},
        {text: 'Cool challenges;'},
        {text: 'G.O.A.T. prizes and experiences;'},
        {text: 'Interactive games, fun and good mood;'},
        {text: 'Access to G.O.A.T. events at Kozel locations;'},
        {text: 'You connect with great people, over a most Delicious Czech beeeeer!'},
    ]
    return (
        <Grid container className={myGroup.container}>
            <Grid item xs={12}>
                <TeaserInviteFriends/>
            </Grid>
            <Grid item xs={12}>
                <MyGroupMix/>
            </Grid>
            <Grid item xs={12}>
                <GameSpinBottleHistory/>
            </Grid>
            <Grid item xs={12}>
                <UntoldMixologist/>
            </Grid>
            <Grid item xs={12}>
                <Typography className={myGroup.text}>We're waiting for your group of friends</Typography>
                <Typography className={myGroup.text}>Check in at a Kozel corner @UNTOLD, access the challenges and win prizes and experiences for your group!</Typography>
            </Grid>
            <Grid item xs={12}>
                <DidYouKnowComponent title={'What awaits you here:'}>
                    <ListInfo items={listInfoItems}/>
                </DidYouKnowComponent>
            </Grid>
        </Grid>
    )
}

export default MyGroup;